import { ReactNode } from 'react';

export interface IRotateAnimatedViewProps {
  children: ReactNode;
  isRotated?: boolean;
  fromDeg?: number;
  toDeg?: number;
}
